import React from "react";
import LegalPage from "@/components/LegalPage";

export default function TermsConditions() {
  return <LegalPage namespace="terms" testId="terms-conditions-page" />;
}
